import AtomicAppDetails from "../../../../src/courses/partials/atomic/app-details.mdx";
import * as React from 'react';
export default {
  AtomicAppDetails,
  React
};